.revoke {
  border: none;
  background: none;
  padding: 6px 0 6px 8px;
  color: var(--danger);
  font: inherit;
  font-size: 14px;
  cursor: pointer;
}
.revoke:disabled { opacity: 0.5; }
.hint, .error {
  margin: 8px 4px 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--muted);
}
.error { color: var(--danger); }
